<template lang="pug">
section.p-top
  section.container
    .text-center
      .d-flex.justify-content-center.align-items-center.cart-bg
        vue-typed-js(:strings="['欢迎加入99Ro~祝您游玩愉快~']", :fadeOut="true")
          h3.text-white.typing.cart-text
    .my-5.row.justify-content-center
      .col-md-3.text-center
        router-link.nav-link.font-weight-bold.p-5(to="/account/register")
          img(
            src="http://res.99ro.top/web-assets/img/5.jpg",
            alt="注册账号",
            srcset="",
            style="width:150px; height:150px; margin-bottom:16px;"
          )
          br
          h4.text-info 注册账号
      .col-md-3.text-center
        router-link.nav-link.font-weight-bold.p-5(to="/account/resetpassword")
          img(
            src="http://res.99ro.top/web-assets/img/6.jpg",
            alt="重置密码",
            srcset="",
            style="width:150px; height:150px; margin-bottom:16px;"
          )
          br
          h4.text-info 重置密码
</template>

<script>
/* global $ */
export default {
  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.p-top {
  padding-top: 91px;
}
.cart-bg {
  background-image: url(http://res.99ro.top/web-assets/img/background3.jpg);
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 375px;
}
.cart-text {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/AccountIndex.vue